import React, { Component } from "react";
import { Provider } from "react-redux";
import GamesList from "./GamesList/GamesList.component";
import { gamesStore } from "../../store/store";
import { Route, Switch } from "react-router-dom";
import GameConfigurations from "./GameConfigurations/GameConfigurations.component";
import GameBundles from "./GameBundles/GameBundles.component";
import GameImport from "./GameImport/GameImport.component";
import { checkPermission } from "../../../../utils/Authorization/authorization";
import Attributes from "./Attributes/Attributes.component";

import Footer from "../../../home/components/Footer/footer.component";

import "./GamesPage.component.scss";

class GamesPage extends Component {
    render() {
        return (
            <Provider store={gamesStore}>
                <div id="GamesPage">
                    <Switch>
                        {checkPermission("list_games") && (
                            <Route
                                exact
                                path={"/games"}
                                component={GamesList}
                            />
                        )}
                        {checkPermission("list_bundles") && (
                            <Route
                                path={"/games/bundles"}
                                component={GameBundles}
                            />
                        )}
                        {/*<Route path={"/games/import"} component={GameImport} />*/}
                        {checkPermission("list_games") && (
                            <Route path={"/games/game/500"} component={GamesList} />
                        )}
                        <Route
                            path={"/games/attributes"}
                            component={Attributes}
                        />
                        {checkPermission("list_game_configs") && (
                            <Route
                                path={"/games/game/:gameId"}
                                component={GameConfigurations}
                            />
                        )}
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default GamesPage;
